function getCloudName(media: string) {
  if (!media || typeof media !== 'string')
    return import.meta.env.VITE_CLOUDINARY_CLOUD_NAME || 'c'

  // Extract the cloud name from the Cloudinary URL
  if (media.includes('cloudinary.com')) {
    // Format: https://res.cloudinary.com/cloud_name/...
    const urlParts = media.split('cloudinary.com/')
    if (urlParts.length > 1) {
      const afterDomain = urlParts[1]
      // The cloud name is the first part after the domain
      const cloudName = afterDomain.split('/')[0]
      return cloudName
    }
  }
  return import.meta.env.VITE_CLOUDINARY_CLOUD_NAME || 'c'
}

function getCloudinaryPublicId(url: string | null, cloudFolder: string) {
  // Ensure the URL is valid
  if (!url || typeof url !== 'string') {
    return null
  }

  // If it's already a public ID (doesn't start with http), return it
  if (!url.startsWith('http')) {
    const fileName = url.split('.')[0]
    if (fileName.includes('/')) return fileName
    return `${cloudFolder}/${fileName}`
  }

  try {
    const urlObj = new URL(url)
    const pathSegments = urlObj.pathname.split('/')

    // Find 'upload' segment
    const uploadIndex = pathSegments.findIndex(s => s === 'upload')
    if (uploadIndex !== -1) {
      let startIndex = uploadIndex + 1
      // Skip version segment (v123456789) or transformation segments
      while (
        startIndex < pathSegments.length &&
        (pathSegments[startIndex].startsWith('v') ||
          pathSegments[startIndex].includes(','))
      ) {
        startIndex++
      }

      const fullPublicIdWithExt = pathSegments.slice(startIndex).join('/')
      // Remove file extension
      return fullPublicIdWithExt.replace(/\.[^/.]+$/, '')
    }

    // Fallback: take last segment
    const lastSegment = pathSegments[pathSegments.length - 1]
    const fileName = lastSegment.split('.')[0]
    return `${cloudFolder}/${fileName}`
  } catch (error) {
    const fileName = url.split('/').pop()?.split('.')[0]
    return fileName ? `${cloudFolder}/${fileName}` : null
  }
}

export { getCloudName, getCloudinaryPublicId }
export default getCloudinaryPublicId
